import { api, apiResolve, useApiGet } from '@sierralabs/core-ui';
export function findReports(params = {}) {
    const request = api.get('reports', params);
    const result = apiResolve(request);
    return { request, result };
}
export function useFindReports() {
    const { data, isLoading, error, get } = useApiGet('reports');
    return {
        reportList: data,
        loadingReports: isLoading,
        loadingReportsError: error,
        findReports: get
    };
}
//# sourceMappingURL=useFindReports.js.map